import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment-timezone';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const APP_TIMEZONE = process.env.REACT_APP_TIMEZONE || 'America/New_York';

const Dashboard = () => {
  const { isAdmin, user } = useAuth();
  const [showSubmitNotification, setShowSubmitNotification] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  // Helper function to check if PTO can be deleted
  // const canDeletePTO = (pto) => {
  //   // Cannot delete approved PTOs that are in the past (already used)
  //   const ptoDate = moment.tz(pto.date, APP_TIMEZONE);
  //   const today = moment.tz(APP_TIMEZONE).startOf('day');
  //   const isPast = ptoDate.isBefore(today);
  //   
  //   if (pto.status === 'approved' && isPast) {
  //     return false;
  //   }
  //   
  //   return true;
  // };

  // Helper function to check if selected week is eligible for upload
  // Anyone can upload screenshot for the week until next Wednesday
  const isWeekEligibleForUpload = () => {
    const today = moment.tz(APP_TIMEZONE).startOf('day');
    const weekEndDate = moment.tz(weekEnd, APP_TIMEZONE);
    
    // Find the Wednesday after the week ends
    // If week ends on Sunday, next Wednesday would be 3 days later
    const nextWednesday = weekEndDate.clone().day(10); // day(10) = next week Wednesday (3 + 7)
    
    // Can upload until (and including) the next Wednesday
    return today.isSameOrBefore(nextWednesday, 'day');
  };
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState('week'); // 'week', 'month', 'year'
  const [weekStart, setWeekStart] = useState(moment.tz(APP_TIMEZONE).startOf('week'));
  const [weekEnd, setWeekEnd] = useState(moment.tz(APP_TIMEZONE).endOf('week'));
  const [month, setMonth] = useState(moment.tz(APP_TIMEZONE).format('YYYY-MM'));
  const [year, setYear] = useState(moment.tz(APP_TIMEZONE).format('YYYY'));
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editingTimesheet, setEditingTimesheet] = useState(null);
  const [editFormData, setEditFormData] = useState({
    hours: {
      sunday: 0,
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0
    },
    notes: ''
  });
  const [saving, setSaving] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [uploadFormData, setUploadFormData] = useState({
    userId: '',
    weekStartDate: moment.tz(APP_TIMEZONE).startOf('week').format('YYYY-MM-DD'),
    weekEndDate: moment.tz(APP_TIMEZONE).endOf('week').format('YYYY-MM-DD')
  });
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [showManualInputModal, setShowManualInputModal] = useState(false);
  const [manualInputSaving, setManualInputSaving] = useState(false);
  const [manualInputFormData, setManualInputFormData] = useState({
    userId: '',
    weekStartDate: moment.tz(APP_TIMEZONE).startOf('week').format('YYYY-MM-DD'),
    weekEndDate: moment.tz(APP_TIMEZONE).endOf('week').format('YYYY-MM-DD'),
    hours: {
      sunday: 0,
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0
    },
    notes: ''
  });
  // const [showPTOModal, setShowPTOModal] = useState(false);
  // const [ptoFormData, setPTOFormData] = useState({
  //   startDate: moment().format('YYYY-MM-DD'),
  //   endDate: moment().format('YYYY-MM-DD'),
  //   hoursPerDay: 8,
  //   type: 'vacation',
  //   reason: ''
  // });
  // const [ptoBalance, setPTOBalance] = useState(null);
  // const [ptos, setPTOs] = useState([]);
  // const [loadingPTO, setLoadingPTO] = useState(false);

  const fetchReport = useCallback(async () => {
    try {
      setLoading(true);
      const params = { viewMode };
      
      if (viewMode === 'week') {
        params.weekStart = weekStart.format('YYYY-MM-DD');
        params.weekEnd = weekEnd.format('YYYY-MM-DD');
      } else if (viewMode === 'month') {
        params.month = month.split('-')[1]; // MM
        params.year = month.split('-')[0]; // YYYY
      } else if (viewMode === 'year') {
        params.year = year;
      }

      const response = await axios.get(`${API_URL}/reports/weekly`, { params });
      console.log('Report data:', response.data.report); // Debug log
      setReport(response.data.report);
    } catch (error) {
      console.error('Error fetching report:', error);
    } finally {
      setLoading(false);
    }
  }, [viewMode, weekStart, weekEnd, month, year]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_URL}/users`);
      setUsers(response.data.users.filter(u => u.isActive));
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // const fetchPTOBalance = async () => {
  //   try {
  //     const response = await axios.get(`${API_URL}/pto/balance`);
  //     setPTOBalance(response.data.balance);
  //   } catch (error) {
  //     console.error('Error fetching PTO balance:', error);
  //   }
  // };

  // const fetchPTOs = async () => {
  //   try {
  //     setLoadingPTO(true);
  //     const currentYear = moment().year();
  //     const response = await axios.get(`${API_URL}/pto`, {
  //       params: { year: currentYear }
  //     });
  //     setPTOs(response.data.ptos);
  //   } catch (error) {
  //     console.error('Error fetching PTOs:', error);
  //   } finally {
  //     setLoadingPTO(false);
  //   }
  // };

  useEffect(() => {
    fetchReport();
    if (isAdmin) {
      fetchUsers();
    } // else {
    //   fetchPTOBalance();
    //   fetchPTOs();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weekStart, weekEnd, month, year, viewMode, isAdmin, fetchReport]);

  // Check for submit notification from Upload page
  useEffect(() => {
    const shouldShowNotification = sessionStorage.getItem('showSubmitNotification');
    console.log('Checking notification flag:', shouldShowNotification);
    if (shouldShowNotification === 'true') {
      console.log('Setting notification to true');
      setShowSubmitNotification(true);
      // Clear the flag
      sessionStorage.removeItem('showSubmitNotification');
      // Clear the notification after 5 seconds
      const timer = setTimeout(() => {
        setShowSubmitNotification(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []); // Run once on mount

  // Set up Server-Sent Events for real-time updates
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    // EventSource doesn't support custom headers, so we pass token as query parameter
    const eventSourceUrl = `${API_URL}/events/timesheet-events?token=${encodeURIComponent(token)}`;
    const eventSource = new EventSource(eventSourceUrl);

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        
        if (data.type === 'timesheet-processed' || data.type === 'timesheet-error') {
          // Refresh the report when a timesheet is processed
          fetchReport();
        }
      } catch (error) {
        console.error('Error parsing SSE event:', error);
      }
    };

    eventSource.onerror = (error) => {
      console.error('SSE connection error:', error);
      // EventSource will automatically reconnect
    };

    return () => {
      eventSource.close();
    };
  }, [fetchReport]);

  const handlePeriodChange = (direction) => {
    if (viewMode === 'week') {
      if (direction === 'prev') {
        setWeekStart(weekStart.clone().subtract(1, 'week'));
        setWeekEnd(weekEnd.clone().subtract(1, 'week'));
      } else {
        setWeekStart(weekStart.clone().add(1, 'week'));
        setWeekEnd(weekEnd.clone().add(1, 'week'));
      }
    } else if (viewMode === 'month') {
      const currentMonth = moment(month);
      if (direction === 'prev') {
        setMonth(currentMonth.clone().subtract(1, 'month').format('YYYY-MM'));
      } else {
        setMonth(currentMonth.clone().add(1, 'month').format('YYYY-MM'));
      }
    } else if (viewMode === 'year') {
      if (direction === 'prev') {
        setYear(moment(year, 'YYYY').clone().subtract(1, 'year').format('YYYY'));
      } else {
        setYear(moment(year, 'YYYY').clone().add(1, 'year').format('YYYY'));
      }
    }
  };

  const getPeriodDisplay = () => {
    if (viewMode === 'week') {
      return `${weekStart.format('MMM DD, YYYY')} - ${weekEnd.format('MMM DD, YYYY')}`;
    } else if (viewMode === 'month') {
      return moment(month, 'YYYY-MM').format('MMMM YYYY');
    } else if (viewMode === 'year') {
      return year;
    }
    return '';
  };

  const downloadReport = async () => {
    try {
      const params = { viewMode };
      
      if (viewMode === 'week') {
        params.weekStart = weekStart.format('YYYY-MM-DD');
        params.weekEnd = weekEnd.format('YYYY-MM-DD');
      } else if (viewMode === 'month') {
        params.month = month.split('-')[1]; // MM
        params.year = month.split('-')[0]; // YYYY
      } else if (viewMode === 'year') {
        params.year = year;
      }

      const response = await axios.get(`${API_URL}/reports/download-excel`, {
        params,
        responseType: 'blob'
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from Content-Disposition header or create default
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'Timesheet_Report.xlsx';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="([^"]+)"|filename=([^;\s]+)/i);
        if (fileNameMatch) {
          fileName = fileNameMatch[1] || fileNameMatch[2];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Error downloading report: ' + (error.response?.data?.message || error.message));
    }
  };

  const downloadPTOReport = async () => {
    try {
      const params = { viewMode };
      
      if (viewMode === 'week') {
        params.weekStart = weekStart.format('YYYY-MM-DD');
        params.weekEnd = weekEnd.format('YYYY-MM-DD');
      } else if (viewMode === 'month') {
        params.month = month.split('-')[1]; // MM
        params.year = month.split('-')[0]; // YYYY
      } else if (viewMode === 'year') {
        params.year = year;
      }

      const response = await axios.get(`${API_URL}/reports/download-pto-excel`, {
        params,
        responseType: 'blob'
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from Content-Disposition header or create default
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'PTO_Hours_Report.xlsx';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename=\"([^\"]+)\"|filename=([^;\\s]+)/i);
        if (fileNameMatch) {
          fileName = fileNameMatch[1] || fileNameMatch[2];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PTO report:', error);
      alert('Error downloading PTO report: ' + (error.response?.data?.message || error.message));
    }
  };

  const downloadScreenshot = async (timesheetId, fileName) => {
    try {
      const response = await axios.get(`${API_URL}/reports/download-screenshot/${timesheetId}`, {
        responseType: 'blob'
      });
      
      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let downloadFileName = fileName; // Use parameter as fallback
      if (contentDisposition) {
        // Try to extract filename from header (handles both quoted and unquoted filenames)
        const filenameRegex = /filename[^;=\n]*=((['"])([^"]*)\2|([^;\n]*))/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && (matches[3] || matches[4])) {
          downloadFileName = matches[3] || matches[4];
        }
      }
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', downloadFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading screenshot:', error);
      const message = error.response?.data?.message || '';
      // Don't alert when it's a manual timesheet (button is disabled, but keep this as a safeguard)
      if (message && message.toLowerCase().includes('entered manually')) return;
      alert(message || 'Error downloading screenshot');
    }
  };

  const downloadScreenshots = async () => {
    try {
      const params = { viewMode };
      
      if (viewMode === 'week') {
        params.weekStart = weekStart.format('YYYY-MM-DD');
        params.weekEnd = weekEnd.format('YYYY-MM-DD');
      } else if (viewMode === 'month') {
        params.month = month.split('-')[1]; // MM
        params.year = month.split('-')[0]; // YYYY
      } else if (viewMode === 'year') {
        params.year = year;
      }

      const response = await axios.get(`${API_URL}/reports/download-screenshots`, {
        params,
        responseType: 'blob'
      });

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from Content-Disposition header or create default
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'screenshots.pdf';
      console.log(response.headers);
      if (contentDisposition) {
        // Try to extract filename from header (handles both quoted and unquoted filenames)
        const filenameRegex = /filename[^;=\n]*=((['"])([^"]*)\2|([^;\n]*))/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && (matches[3] || matches[4])) {
          fileName = matches[3] || matches[4];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading screenshots:', error);
      alert('Error downloading screenshots: ' + (error.response?.data?.message || error.message));
    }
  };

  // Check if a timesheet is editable by an associate
  const isTimesheetEditable = (associate) => {
    if (isAdmin) return true; // Admins can always edit
    
    // Associates can only edit their own timesheets
    if (associate.userId !== user?.id) return false;
    
    // Check if timesheet is for current week
    const now = moment();
    const currentWeekStart = now.clone().startOf('week');
    const currentWeekEnd = now.clone().endOf('week');
    
    if (!associate.weekStartDate || !associate.weekEndDate) return false;
    
    const timesheetWeekStart = moment(associate.weekStartDate).startOf('day');
    const timesheetWeekEnd = moment(associate.weekEndDate).endOf('day');
    
    // Must be current week
    if (!timesheetWeekStart.isSame(currentWeekStart, 'day') || !timesheetWeekEnd.isSame(currentWeekEnd, 'day')) {
      return false;
    }
    
    // Must be before or on next Monday (deadline is end of next Monday)
    const nextMonday = now.clone().add(1, 'week').startOf('week').add(1, 'day'); // Next Monday
    if (now.isAfter(nextMonday, 'day')) {
      return false;
    }
    
    return true;
  };

  const handleEditClick = (associate) => {
    setEditingTimesheet(associate);
    setEditFormData({
      hours: {
        sunday: associate.hours.sunday || 0,
        monday: associate.hours.monday || 0,
        tuesday: associate.hours.tuesday || 0,
        wednesday: associate.hours.wednesday || 0,
        thursday: associate.hours.thursday || 0,
        friday: associate.hours.friday || 0,
        saturday: associate.hours.saturday || 0
      },
      notes: associate.notes || ''
    });
  };

  const handleEditFormChange = (day, value) => {
    setEditFormData(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [day]: parseFloat(value) || 0
      }
    }));
  };

  const handleNotesChange = (value) => {
    setEditFormData(prev => ({
      ...prev,
      notes: value
    }));
  };

  const calculateTotal = () => {
    const { hours } = editFormData;
    return Object.values(hours).reduce((sum, val) => sum + (parseFloat(val) || 0), 0).toFixed(2);
  };

  const handleSaveTimesheet = async () => {
    if (!editingTimesheet) return;

    try {
      setSaving(true);

      // Determine the week dates - use timesheet dates if available, otherwise use current view dates
      let weekStartDate, weekEndDate;
      if (editingTimesheet.weekStartDate && editingTimesheet.weekEndDate) {
        weekStartDate = moment(editingTimesheet.weekStartDate).format('YYYY-MM-DD');
        weekEndDate = moment(editingTimesheet.weekEndDate).format('YYYY-MM-DD');
      } else if (viewMode === 'week') {
        weekStartDate = weekStart.format('YYYY-MM-DD');
        weekEndDate = weekEnd.format('YYYY-MM-DD');
      } else {
        // For month/year views, default to current week
        const now = moment();
        weekStartDate = now.clone().startOf('week').format('YYYY-MM-DD');
        weekEndDate = now.clone().endOf('week').format('YYYY-MM-DD');
      }

      // Try to update existing timesheet first
      if (editingTimesheet.id) {
        try {
          await axios.put(`${API_URL}/upload/${editingTimesheet.id}`, {
            hours: editFormData.hours,
            notes: editFormData.notes
          });
        } catch (error) {
          // If update fails (404), create new timesheet
          if (error.response?.status === 404) {
            if (editingTimesheet.userId) {
              await axios.post(`${API_URL}/upload/admin/create`, {
                userId: editingTimesheet.userId,
                weekStartDate,
                weekEndDate,
                hours: editFormData.hours,
                notes: editFormData.notes
              });
            } else {
              throw new Error('User ID not found');
            }
          } else {
            throw error;
          }
        }
      } else {
        // Create new timesheet
        if (editingTimesheet.userId) {
          await axios.post(`${API_URL}/upload/admin/create`, {
            userId: editingTimesheet.userId,
            weekStartDate,
            weekEndDate,
            hours: editFormData.hours,
            notes: editFormData.notes
          });
        } else {
          throw new Error('User ID not found. Cannot create timesheet.');
        }
      }

      // Refresh the report
      await fetchReport();
      setEditingTimesheet(null);
      alert('Timesheet updated successfully!');
    } catch (error) {
      console.error('Error saving timesheet:', error);
      alert('Error saving timesheet: ' + (error.response?.data?.message || error.message));
    } finally {
      setSaving(false);
    }
  };

  const handleCloseModal = () => {
    setEditingTimesheet(null);
    setEditFormData({
      hours: {
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0
      },
      notes: ''
    });
  };

  const handleUploadDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleUploadDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleUploadFile(e.dataTransfer.files[0]);
    }
  };

  const handleUploadFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleUploadFile(e.target.files[0]);
    }
  };

  const handleUploadFile = async (file) => {
    if (!uploadFormData.userId) {
      alert('Please select an associate');
      return;
    }

    // Validate file type
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/webp'
    ];
    
    if (!allowedTypes.includes(file.type)) {
      alert('Only PDF and image files (JPG, PNG, GIF, WEBP) are allowed');
      return;
    }

    try {
      setUploading(true);
      
      // Convert file to base64
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          // Remove the data URL prefix (e.g., "data:image/png;base64,")
          const base64 = reader.result.split(',')[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      // Send JSON data instead of FormData
      await axios.post(`${API_URL}/upload/admin/upload`, {
        base64Data: base64Data,
        mimeType: file.type,
        fileName: file.name,
        userId: uploadFormData.userId,
        weekStartDate: uploadFormData.weekStartDate,
        weekEndDate: uploadFormData.weekEndDate
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      alert('File uploaded successfully! Processing in progress.');
      setShowUploadModal(false);
      setUploadFormData({
        userId: '',
        weekStartDate: moment.tz(APP_TIMEZONE).startOf('week').format('YYYY-MM-DD'),
        weekEndDate: moment.tz(APP_TIMEZONE).endOf('week').format('YYYY-MM-DD')
      });
      // Refresh the report
      await fetchReport();
    } catch (error) {
      alert(error.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const handleWeekDateChange = (field, value) => {
    setUploadFormData(prev => {
      const newData = { ...prev, [field]: value };
      // Auto-adjust week end date if week start changes
      if (field === 'weekStartDate') {
        const start = moment.tz(value, APP_TIMEZONE);
        const end = start.clone().endOf('week');
        newData.weekEndDate = end.format('YYYY-MM-DD');
      }
      return newData;
    });
  };

  const handleManualInputWeekDateChange = (field, value) => {
    setManualInputFormData(prev => {
      const newData = { ...prev, [field]: value };
      if (field === 'weekStartDate') {
        const start = moment.tz(value, APP_TIMEZONE);
        const end = start.clone().endOf('week');
        newData.weekEndDate = end.format('YYYY-MM-DD');
      }
      return newData;
    });
  };

  const handleManualInputDayChange = (day, value) => {
    setManualInputFormData(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [day]: parseFloat(value) || 0
      }
    }));
  };

  const handleManualInputNotesChange = (value) => {
    setManualInputFormData(prev => ({ ...prev, notes: value }));
  };

  const manualInputTotalHours = () => {
    const { hours } = manualInputFormData;
    return Object.values(hours).reduce((sum, val) => sum + (parseFloat(val) || 0), 0).toFixed(2);
  };

  const handleManualInputSave = async () => {
    if (!manualInputFormData.userId) {
      alert('Please select a user');
      return;
    }
    try {
      setManualInputSaving(true);
      await axios.post(`${API_URL}/upload/admin/create`, {
        userId: Number(manualInputFormData.userId),
        weekStartDate: manualInputFormData.weekStartDate,
        weekEndDate: manualInputFormData.weekEndDate,
        hours: manualInputFormData.hours,
        notes: manualInputFormData.notes || ''
      });
      setShowManualInputModal(false);
      setManualInputFormData({
        userId: '',
        weekStartDate: moment.tz(APP_TIMEZONE).startOf('week').format('YYYY-MM-DD'),
        weekEndDate: moment.tz(APP_TIMEZONE).endOf('week').format('YYYY-MM-DD'),
        hours: {
          sunday: 0,
          monday: 0,
          tuesday: 0,
          wednesday: 0,
          thursday: 0,
          friday: 0,
          saturday: 0
        },
        notes: ''
      });
      await fetchReport();
      alert('Timesheet saved successfully!');
    } catch (error) {
      console.error('Error saving manual timesheet:', error);
      alert(error.response?.data?.message || 'Failed to save timesheet');
    } finally {
      setManualInputSaving(false);
    }
  };

  const handleCloseManualInputModal = () => {
    setShowManualInputModal(false);
    setManualInputFormData({
      userId: '',
      weekStartDate: moment.tz(APP_TIMEZONE).startOf('week').format('YYYY-MM-DD'),
      weekEndDate: moment.tz(APP_TIMEZONE).endOf('week').format('YYYY-MM-DD'),
      hours: {
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0
      },
      notes: ''
    });
  };

  // const handlePTOSubmit = async (e) => {
  //   e.preventDefault();
  //   
  //   try {
  //     const startDate = moment(ptoFormData.startDate);
  //     const endDate = moment(ptoFormData.endDate);
  //     
  //     // Validate date range
  //     if (endDate.isBefore(startDate)) {
  //       alert('End date must be after or equal to start date');
  //       return;
  //     }
  //     
  //     // Calculate number of days
  //     const daysDiff = endDate.diff(startDate, 'days') + 1;
  //     
  //     if (daysDiff > 365) {
  //       alert('Date range cannot exceed 365 days');
  //       return;
  //     }
  //     
  //     // Count weekdays only (exclude Saturday and Sunday)
  //     let weekdayCount = 0;
  //     for (let i = 0; i < daysDiff; i++) {
  //       const currentDate = startDate.clone().add(i, 'days');
  //       const dayOfWeek = currentDate.day(); // 0=Sunday, 6=Saturday
  //       if (dayOfWeek !== 0 && dayOfWeek !== 6) {
  //         weekdayCount++;
  //       }
  //     }
  //     
  //     // Check if request exceeds PTO balance
  //     const requestedHours = weekdayCount * ptoFormData.hoursPerDay;
  //     if (ptoBalance && requestedHours > ptoBalance.ptoRemaining) {
  //       const confirmExceed = window.confirm(
  //         `⚠️ WARNING: You are requesting ${Math.round(requestedHours)} hour(s) but only have ${Math.round(ptoBalance.ptoRemaining)} hour(s) remaining.\\n\\n` +
  //         `This request will likely be rejected. Do you want to continue anyway?`
  //       );
  //       if (!confirmExceed) {
  //         return;
  //       }
  //     }
  //     
  //     // Create PTO requests for each weekday in the range (excluding weekends)
  //     let successCount = 0;
  //     let failedDates = [];
  //     
  //     for (let i = 0; i < daysDiff; i++) {
  //       const currentDate = startDate.clone().add(i, 'days');
  //       const dayOfWeek = currentDate.day(); // 0=Sunday, 6=Saturday
  //       
  //       // Skip weekends
  //       if (dayOfWeek === 0 || dayOfWeek === 6) {
  //         continue;
  //       }
  //       
  //       try {
  //         await axios.post(`${API_URL}/pto`, {
  //           date: currentDate.format('YYYY-MM-DD'),
  //           hours: ptoFormData.hoursPerDay,
  //           type: ptoFormData.type,
  //           reason: ptoFormData.reason
  //         });
  //         successCount++;
  //       } catch (error) {
  //         // If it's a duplicate, skip but don't fail the whole process
  //         if (error.response?.data?.message?.includes('already exists')) {
  //           failedDates.push(`${currentDate.format('MMM DD')} (already exists)`);
  //         } else {
  //           failedDates.push(`${currentDate.format('MMM DD')} (${error.response?.data?.message || 'error'})`);
  //         }
  //       }
  //     }
  //     
  //     // Show appropriate message
  //     if (successCount > 0 && failedDates.length === 0) {
  //       alert(`✓ PTO request submitted successfully for ${successCount} day(s)!`);
  //     } else if (successCount > 0 && failedDates.length > 0) {
  //       alert(`✓ ${successCount} day(s) submitted successfully.\\n\\n⚠ Failed for: ${failedDates.join(', ')}`);
  //     } else {
  //       alert(`⚠ No PTO requests were created.\\n\\nFailed for: ${failedDates.join(', ')}`);
  //     }
  //     
  //     setShowPTOModal(false);
  //     setPTOFormData({
  //       startDate: moment().format('YYYY-MM-DD'),
  //       endDate: moment().format('YYYY-MM-DD'),
  //       hoursPerDay: 8,
  //       type: 'vacation',
  //       reason: ''
  //     });
  //     fetchPTOBalance();
  //     fetchPTOs();
  //   } catch (error) {
  //     alert(error.response?.data?.message || 'Failed to submit PTO request');
  //   }
  // };

  // const handlePTODelete = async (ptoId) => {
  //   if (!window.confirm('Are you sure you want to delete this PTO request?')) {
  //     return;
  //   }

  //   try {
  //     await axios.delete(`${API_URL}/pto/${ptoId}`);
  //     alert('PTO deleted successfully!');
  //     fetchPTOBalance();
  //     fetchPTOs();
  //   } catch (error) {
  //     alert(error.response?.data?.message || 'Failed to delete PTO');
  //   }
  // };

  const handleDeleteTimesheet = async (timesheetId, associateName) => {
    if (!window.confirm(`Are you sure you want to delete the timesheet for ${associateName}?`)) {
      return;
    }

    try {
      await axios.delete(`${API_URL}/upload/${timesheetId}`);
      alert('Timesheet deleted successfully!');
      fetchReport();
    } catch (error) {
      console.error('Error deleting timesheet:', error);
      alert(error.response?.data?.message || 'Failed to delete timesheet');
    }
  };

  // Helper function to get PTO info for a specific user and date
  const getPTOForDate = (userId, date) => {
    if (!report?.ptoData || !userId) {
      return null;
    }
    const dateKey = moment(date).format('YYYY-MM-DD');
    return report.ptoData[userId]?.[dateKey] || null;
  };

  // Helper function to get total PTO hours for a date range
  const getPTOForDateRange = (userId, startDate, endDate) => {
    if (!report?.ptoData || !userId) {
      return 0;
    }
    
    const start = moment(startDate);
    const end = moment(endDate);
    let totalPTOHours = 0;
    
    // Iterate through each day in the range
    const currentDate = start.clone();
    while (currentDate.isSameOrBefore(end, 'day')) {
      const dateKey = currentDate.format('YYYY-MM-DD');
      const pto = report.ptoData[userId]?.[dateKey];
      if (pto) {
        totalPTOHours += parseFloat(pto.hours) || 0;
      }
      currentDate.add(1, 'day');
    }
    
    return totalPTOHours;
  };

  // Helper function to render cell with hours and PTO
  const renderHoursCell = (hours, userId, date) => {
    const pto = getPTOForDate(userId, date);
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
        <div style={{ fontWeight: pto ? '600' : 'normal' }}>{hours || 0}</div>
        {pto && (
          <div style={{ 
            fontSize: '10px', 
            color: '#fff', 
            background: '#4caf50', 
            padding: '3px 6px', 
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            fontWeight: '500',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }} title={`${pto.type.charAt(0).toUpperCase() + pto.type.slice(1)}${pto.reason ? ': ' + pto.reason : ''}`}>
            🏖️ PTO: {pto.hours}h
          </div>
        )}
      </div>
    );
  };

  // Helper function to render cell with hours and aggregated PTO for year view
  const renderYearlyHoursCell = (hours, userId, columnKey) => {
    // For year view, columnKey is like "month1", "month2", etc.
    // PTO data structure for year view: { userId: { month1: { hours: X }, month2: { hours: Y }, ... } }
    const pto = report?.ptoData?.[userId]?.[columnKey];
    const totalPTO = pto ? (parseFloat(pto.hours) || 0) : 0;
    
    // Extract month number for display purposes
    const monthMatch = columnKey.match(/month(\d+)/);
    const monthNumber = monthMatch ? parseInt(monthMatch[1]) : null;
    const monthName = monthNumber ? moment(`${year}-${monthNumber.toString().padStart(2, '0')}-01`).format('MMMM') : '';
    
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
        <div style={{ fontWeight: totalPTO > 0 ? '600' : 'normal' }}>{hours || 0}</div>
        {totalPTO > 0 && (
          <div style={{ 
            fontSize: '10px', 
            color: '#fff', 
            background: '#4caf50', 
            padding: '3px 6px', 
            borderRadius: '4px',
            whiteSpace: 'nowrap',
            fontWeight: '500',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }} title={`Total PTO in ${monthName}`}>
            🏖️ PTO: {totalPTO.toFixed(1)}h
          </div>
        )}
      </div>
    );
  };

  return (
    <Layout>
      <div className="dashboard">
        {console.log('showSubmitNotification:', showSubmitNotification)}
        {showSubmitNotification && (
          <div className="submit-notification" style={{ 
            backgroundColor: '#d4edda', 
            border: '1px solid #28a745',
            borderRadius: '4px',
            padding: '12px 16px',
            marginBottom: '20px',
            color: '#155724',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            animation: 'fadeIn 0.3s ease-in'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '20px' }}>✓</span>
              <strong>Thanks for submitting the report!</strong>
            </div>
            <button
              onClick={() => setShowSubmitNotification(false)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#155724',
                padding: '0 8px'
              }}
            >
              ×
            </button>
          </div>
        )}
        <div className="dashboard-header">
          <div className="date-selector-container">
            <div className="view-mode-selector">
              <button 
                className={viewMode === 'week' ? 'active' : ''}
                onClick={() => setViewMode('week')}
              >
                Week
              </button>
              <button 
                className={viewMode === 'month' ? 'active' : ''}
                onClick={() => setViewMode('month')}
              >
                Month
              </button>
              <button 
                className={viewMode === 'year' ? 'active' : ''}
                onClick={() => setViewMode('year')}
              >
                Year
              </button>
            </div>
            <div className="date-selector">
              <button onClick={() => handlePeriodChange('prev')}>←</button>
              <span>{getPeriodDisplay()}</span>
              <button onClick={() => handlePeriodChange('next')}>→</button>
            </div>
          </div>
          {isAdmin ? (
            <div className="action-buttons">
              <button className="btn-primary" onClick={() => setShowUploadModal(true)}>
                ☁️ Upload Screenshot
              </button>
              <button className="btn-primary" onClick={() => setShowManualInputModal(true)}>
                ✏️ Manual Input Hours
              </button>
              <button className="btn-primary" onClick={downloadReport}>
                📥 Download Regular Hours
              </button>
              <button className="btn-primary" onClick={downloadPTOReport}>
                📥 Download PTO Hours
              </button>
              <button className="btn-secondary" onClick={downloadScreenshots}>
                📥 Download All Screenshots
              </button>
            </div>
          ) : (
            <div className="action-buttons action-buttons-centered">
              {isWeekEligibleForUpload() ? (
                <div className="upload-with-guide">
                  <button className="btn-primary btn-upload-large" onClick={() => navigate('/upload')}>
                    ☁️ Upload
                  </button>
                  <div className="guide-icon-wrapper">
                    <button
                      className="guide-icon-btn"
                      onClick={() => setShowGuide(!showGuide)}
                      title="How to upload"
                    >
                      ?
                    </button>
                    {showGuide && (
                      <div className="guide-popup">
                        <div className="guide-popup-header">
                          <span>📋 Upload Guide</span>
                          <button className="guide-close-btn" onClick={() => setShowGuide(false)}>✕</button>
                        </div>
                        <ol className="guide-steps">
                          <li>Take a screenshot of timesheet from Clarity System</li>
                          <li>Save the screenshot as .png file in local file system</li>
                          <li>Use the Upload button to choose the saved screenshot</li>
                          <li>Once upload is complete, click the Submit button</li>
                          <li>You are DONE ✅</li>
                        </ol>
                        <p className="guide-contact">If any error occurs during processing of the screenshot, please contact <a href="mailto:ravi@teacuptechsystems.com">ravi@teacuptechsystems.com</a></p>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="upload-disabled-message">
                  <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    Upload deadline has passed for this week. 
                    <br />
                    Screenshots can only be uploaded until the Wednesday following the week end.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="report-section">
          <h2>
            {isAdmin 
              ? `Associates ${viewMode.charAt(0).toUpperCase() + viewMode.slice(1)}ly Report Summary` 
              : `My ${viewMode.charAt(0).toUpperCase() + viewMode.slice(1)}ly Report Summary`
            }
          </h2>
          <p className="subtitle">
            {isAdmin 
              ? `Overview of associates' hours for the selected ${viewMode}.`
              : `Overview of your hours for the selected ${viewMode}.`
            }
          </p>

          {loading ? (
            <div className="loading">Loading...</div>
          ) : report ? (
            <>
              <div className="summary-cards">
                <div className="summary-card">
                  <div className="card-icon">🕐</div>
                  <div className="card-content">
                    <div className="card-label">Total Hours Reported</div>
                    <div className="card-value">{report.totalHours.toFixed(2)} hrs</div>
                  </div>
                </div>
                {isAdmin && (
                  <>
                    <div className="summary-card">
                      <div className="card-icon">👥</div>
                      <div className="card-content">
                        <div className="card-label">Total Associates</div>
                        <div className="card-value">{report.totalAssociates}</div>
                      </div>
                    </div>
                    <div className="summary-card">
                      <div className="card-icon">📊</div>
                      <div className="card-content">
                        <div className="card-label">Average Hours / Associate</div>
                        <div className="card-value">
                          {report.totalAssociates > 0
                            ? (report.totalHours / report.totalAssociates).toFixed(2)
                            : 0}{' '}
                          hrs
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="report-table-container">
                <table className="report-table">
                <thead>
                  <tr>
                    <th>Serial No.</th>
                    <th>Associate Name</th>
                    {viewMode === 'week' ? (
                      <>
                        <th>Sun<br/>{moment(weekStart).clone().add(0, 'days').format('M/D')}</th>
                        <th>Mon<br/>{moment(weekStart).clone().add(1, 'days').format('M/D')}</th>
                        <th>Tue<br/>{moment(weekStart).clone().add(2, 'days').format('M/D')}</th>
                        <th>Wed<br/>{moment(weekStart).clone().add(3, 'days').format('M/D')}</th>
                        <th>Thu<br/>{moment(weekStart).clone().add(4, 'days').format('M/D')}</th>
                        <th>Fri<br/>{moment(weekStart).clone().add(5, 'days').format('M/D')}</th>
                        <th>Sat<br/>{moment(weekStart).clone().add(6, 'days').format('M/D')}</th>
                      </>
                    ) : report.columns ? (
                        report.columns.map((col, idx) => (
                          <th key={idx}>{col.label}</th>
                        ))
                    ) : (
                      <>
                        <th>Sun</th>
                        <th>Mon</th>
                        <th>Tue</th>
                        <th>Wed</th>
                        <th>Thu</th>
                        <th>Fri</th>
                        <th>Sat</th>
                      </>
                    )}
                    <th>Regular Hours</th>
                    <th>PTO Hours</th>
                    <th>PTO Start</th>
                    <th>PTO Accrued</th>
                    <th>PTO Balance</th>
                    {viewMode === 'week' && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {report.associates
                    .filter(associate => associate.status === 'submitted')
                    .map((associate, index) => (
                    <tr key={index}>
                      <td>{associate.serialNo}</td>
                      <td>{associate.name}</td>
                      {viewMode === 'week' ? (
                        <>
                          <td>{renderHoursCell(associate.hours.sunday, associate.userId, moment(weekStart).clone().add(0, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.monday, associate.userId, moment(weekStart).clone().add(1, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.tuesday, associate.userId, moment(weekStart).clone().add(2, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.wednesday, associate.userId, moment(weekStart).clone().add(3, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.thursday, associate.userId, moment(weekStart).clone().add(4, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.friday, associate.userId, moment(weekStart).clone().add(5, 'days'))}</td>
                          <td>{renderHoursCell(associate.hours.saturday, associate.userId, moment(weekStart).clone().add(6, 'days'))}</td>
                        </>
                      ) : viewMode === 'month' && report.columns ? (
                        report.columns.map((col, idx) => {
                          // For month view, calculate the date from the column key
                          // Column key format is like "day1", "day2", etc.
                          const dayMatch = col.key.match(/day(\d+)/);
                          if (dayMatch) {
                            const dayOfMonth = parseInt(dayMatch[1]);
                            const [year, monthNum] = month.split('-');
                            const cellDate = moment(`${year}-${monthNum}-${dayOfMonth.toString().padStart(2, '0')}`);
                            return <td key={idx}>{renderHoursCell(associate.hours[col.key], associate.userId, cellDate)}</td>;
                          } else {
                            // Fallback for other column types (weeks, etc.)
                            return <td key={idx}>{associate.hours[col.key] || 0}</td>;
                          }
                        })
                      ) : report.columns ? (
                        report.columns.map((col, idx) => (
                          <td key={idx}>{renderYearlyHoursCell(associate.hours[col.key], associate.userId, col.key)}</td>
                        ))
                      ) : null}
                      <td><strong>{associate.totalHours.toFixed(2)}</strong></td>
                      <td>
                        <span style={{ color: associate.ptoHours > 0 ? '#ff9800' : '#666' }}>
                          {associate.ptoHours || 0}
                        </span>
                      </td>
                      <td>{associate.ptoLimit || 0}</td>
                      <td>{associate.ptoAccrued || 0}</td>
                      <td>
                        <span style={{ color: (associate.ptoRemaining || 0) < 40 ? '#ff9800' : '#4caf50' }}>
                          {associate.ptoRemaining || 0}
                        </span>
                      </td>
                      {viewMode === 'week' && (
                        <td>
                          <div style={{ display: 'flex', gap: '5px' }}>
                            {isTimesheetEditable(associate) && (
                              <button 
                                className="btn-edit"
                                onClick={() => handleEditClick(associate)}
                                title="Edit Timesheet"
                              >
                                ✏️
                              </button>
                            )}
                            <span title={associate.hasScreenshot === false ? 'Time was entered manually' : 'Download Screenshot'}>
                              <button 
                                className="btn-download-screenshot"
                                onClick={() => downloadScreenshot(associate.id, `${associate.name}_timesheet.pdf`)}
                                disabled={associate.hasScreenshot === false}
                              >
                                📥
                              </button>
                            </span>
                            {(isAdmin || isTimesheetEditable(associate)) && associate.id && (
                              <button 
                                className="btn-delete"
                                onClick={() => handleDeleteTimesheet(associate.id, associate.name)}
                                title="Delete Timesheet"
                              >
                                🗑️
                              </button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                  {report.associates.length > 0 && isAdmin && (
                    <tr className="total-row">
                      <td colSpan="2"><strong>Total</strong></td>
                      {report.columns ? (
                        report.columns.map((col, idx) => (
                          <td key={idx}><strong>{(report.dailyTotals[col.key] || 0).toFixed(2)}</strong></td>
                        ))
                      ) : (
                        <>
                          <td><strong>{report.dailyTotals.monday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.tuesday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.wednesday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.thursday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.friday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.saturday.toFixed(2)}</strong></td>
                          <td><strong>{report.dailyTotals.sunday.toFixed(2)}</strong></td>
                        </>
                      )}
                      <td><strong>{report.totalHours.toFixed(2)}</strong></td>
                      <td>
                        <strong>
                          {report.associates
                            .filter(a => a.status === 'submitted')
                            .reduce((sum, a) => sum + (parseFloat(a.ptoHours) || 0), 0)
                            .toFixed(2)}
                        </strong>
                      </td>
                      <td>
                        <strong>
                          {report.associates
                            .filter(a => a.status === 'submitted')
                            .reduce((sum, a) => sum + (parseFloat(a.ptoLimit) || 0), 0)
                            .toFixed(2)}
                        </strong>
                      </td>
                      <td>
                        <strong>
                          {report.associates
                            .filter(a => a.status === 'submitted')
                            .reduce((sum, a) => sum + (parseFloat(a.ptoAccrued) || 0), 0)
                            .toFixed(2)}
                        </strong>
                      </td>
                      <td>
                        <strong>
                          {report.associates
                            .filter(a => a.status === 'submitted')
                            .reduce((sum, a) => sum + (parseFloat(a.ptoRemaining) || 0), 0)
                            .toFixed(2)}
                        </strong>
                      </td>
                      {viewMode === 'week' && <td></td>}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
          ) : (
            <div className="no-data">No data available for this {viewMode}</div>
          )}

          {viewMode === 'week' && report && (
            <div style={{ 
              marginTop: '15px', 
              padding: '10px', 
              background: '#f5f5f5', 
              borderRadius: '4px',
              fontSize: '12px',
              color: '#666'
            }}>
              <strong>Legend:</strong> Regular work hours are shown as numbers. PTO (Paid Time Off) is displayed below work hours in blue badges.
            </div>
          )}
        </div>

        {/* PTO Section for Associates */}
        {/* {!isAdmin && (
          <div className="pto-section">
            <div className="section-header">
              <h2>Paid Time Off (PTO)</h2>
              <button className="btn-primary" onClick={() => setShowPTOModal(true)}>
                + Request PTO
              </button>
            </div>

            {ptoBalance && (
              <div className="pto-balance-cards">
                <div className="summary-card">
                  <div className="card-icon">📅</div>
                  <div className="card-content">
                    <div className="card-label">Total PTO Allowance</div>
                    <div className="card-value">{ptoBalance.ptoLimit} hrs</div>
                  </div>
                </div>
                <div className="summary-card">
                  <div className="card-icon">✅</div>
                  <div className="card-content">
                    <div className="card-label">PTO Used</div>
                    <div className="card-value">{ptoBalance.ptoUsed} hrs</div>
                  </div>
                </div>
                <div className="summary-card">
                  <div className="card-icon">⏰</div>
                  <div className="card-content">
                    <div className="card-label">PTO Remaining</div>
                    <div className="card-value">{ptoBalance.ptoRemaining} hrs</div>
                  </div>
                </div>
              </div>
            )}

            <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>My PTO Requests ({moment().year()})</h3>
            {loadingPTO ? (
              <div className="loading">Loading PTOs...</div>
            ) : (
              <div className="pto-table-container">
                <table className="report-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Hours</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Reason</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ptos.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="no-data">No PTO requests found</td>
                      </tr>
                    ) : (
                      ptos.map((pto) => (
                        <tr key={pto.id}>
                          <td>{moment(pto.date).format('MMM DD, YYYY')}</td>
                          <td>{Math.round(pto.hours)} hrs</td>
                          <td>
                            <span className={`role-badge ${pto.type}`}>
                              {pto.type}
                            </span>
                          </td>
                          <td>
                            <span className={`status-badge ${pto.status}`}>
                              {pto.status}
                            </span>
                          </td>
                          <td>{pto.reason || '-'}</td>
                          <td>
                            {canDeletePTO(pto) ? (
                              <button
                                className=\"btn-small btn-delete\"
                                onClick={() => handlePTODelete(pto.id)}
                              >
                                Delete
                              </button>
                            ) : (
                              <span className="text-muted" style={{ fontSize: '12px' }}>Used</span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )} */}
      </div>

      {/* PTO Request Modal */}
      {/* {showPTOModal && (
        <div className="modal-overlay" onClick={() => setShowPTOModal(false)}>
          ... PTO Request Modal content hidden ...
        </div>
      )} */}

      {/* Edit Timesheet Modal */}
      {editingTimesheet && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Edit Timesheet - {editingTimesheet.name}</h3>
                {editingTimesheet.weekStartDate && editingTimesheet.weekEndDate && (
                  <p style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#666' }}>
                    {moment(editingTimesheet.weekStartDate).format('MMM DD, YYYY')} - {moment(editingTimesheet.weekEndDate).format('MMM DD, YYYY')}
                  </p>
                )}
              </div>
              <button className="modal-close" onClick={handleCloseModal}>×</button>
            </div>
            <div className="modal-body">
              <div className="edit-timesheet-form">
                <div className="form-group">
                  <label>
                    Sunday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(0, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(0, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.sunday}
                    onChange={(e) => handleEditFormChange('sunday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Monday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(1, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(1, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.monday}
                    onChange={(e) => handleEditFormChange('monday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Tuesday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(2, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(2, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.tuesday}
                    onChange={(e) => handleEditFormChange('tuesday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Wednesday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(3, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(3, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.wednesday}
                    onChange={(e) => handleEditFormChange('wednesday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Thursday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(4, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(4, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.thursday}
                    onChange={(e) => handleEditFormChange('thursday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Friday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(5, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(5, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.friday}
                    onChange={(e) => handleEditFormChange('friday', e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Saturday
                    {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(6, 'days')) && (
                      <span className="pto-indicator" style={{ marginLeft: '8px', fontSize: '11px', padding: '2px 6px', borderRadius: '3px', backgroundColor: '#4caf50', color: 'white' }}>
                        PTO: {getPTOForDate(editingTimesheet.userId, moment(editingTimesheet.weekStartDate).add(6, 'days')).hours}h
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    step="0.25"
                    min="0"
                    value={editFormData.hours.saturday}
                    onChange={(e) => handleEditFormChange('saturday', e.target.value)}
                  />
                </div>
                <div className="form-group total-display">
                  <label>Regular Hours</label>
                  <div className="total-value">{calculateTotal()}</div>
                </div>
                <div className="form-group">
                  <label>Notes</label>
                  <textarea
                    value={editFormData.notes}
                    onChange={(e) => handleNotesChange(e.target.value)}
                    rows="3"
                    placeholder="Add any notes..."
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={handleCloseModal} disabled={saving}>
                Cancel
              </button>
              <button className="btn-primary" onClick={handleSaveTimesheet} disabled={saving}>
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Admin Upload Modal */}
      {showUploadModal && isAdmin && (
        <div className="modal-overlay" onClick={() => setShowUploadModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Upload Screenshot for Users</h3>
              <button className="modal-close" onClick={() => setShowUploadModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="upload-form">
                <div className="form-group">
                  <label>Select User *</label>
                  <select
                    value={uploadFormData.userId}
                    onChange={(e) => setUploadFormData(prev => ({ ...prev, userId: e.target.value }))}
                    required
                  >
                    <option value="">-- Select User --</option>
                    {users.map(user => (
                      <option key={user.id} value={user.id}>{user.name} ({user.email})</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Week Start Date *</label>
                  <input
                    type="date"
                    value={uploadFormData.weekStartDate}
                    onChange={(e) => handleWeekDateChange('weekStartDate', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Week End Date *</label>
                  <input
                    type="date"
                    value={uploadFormData.weekEndDate}
                    onChange={(e) => handleWeekDateChange('weekEndDate', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Upload File *</label>
                  <div
                    className={`upload-area-small ${dragActive ? 'drag-active' : ''}`}
                    onDragEnter={handleUploadDrag}
                    onDragLeave={handleUploadDrag}
                    onDragOver={handleUploadDrag}
                    onDrop={handleUploadDrop}
                  >
                    <div className="upload-icon-small">☁️</div>
                    <p>Drag and drop your file here, or click to browse</p>
                    <input
                      type="file"
                      id="admin-file-input"
                      accept=".pdf,.jpg,.jpeg,.png,.gif,.webp"
                      onChange={handleUploadFileInput}
                      style={{ display: 'none' }}
                      disabled={uploading}
                    />
                    <button
                      type="button"
                      className="browse-button-small"
                      onClick={() => document.getElementById('admin-file-input').click()}
                      disabled={uploading}
                    >
                      Browse Files
                    </button>
                    {uploading && <p className="uploading-text">Uploading...</p>}
                  </div>
                  <p className="upload-note-small">
                    Supported formats: PDF, JPG, PNG, GIF, WEBP
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-secondary" 
                onClick={() => setShowUploadModal(false)} 
                disabled={uploading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manual Input Hours Modal */}
      {showManualInputModal && isAdmin && (
        <div className="modal-overlay" onClick={handleCloseManualInputModal}>
          <div className="modal-content manual-input-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Manual Input Hours</h3>
                <p className="manual-input-subtitle">Enter weekly hours for an associate without uploading a screenshot.</p>
              </div>
              <button type="button" className="modal-close" onClick={handleCloseManualInputModal} aria-label="Close">×</button>
            </div>
            <div className="modal-body manual-input-body">
              <section className="manual-input-section">
                <h4 className="manual-input-section-title">User & week</h4>
                <div className="manual-input-row">
                  <div className="form-group manual-input-user">
                    <label htmlFor="manual-input-user">Associate <span className="required">*</span></label>
                    <select
                      id="manual-input-user"
                      value={manualInputFormData.userId}
                      onChange={(e) => setManualInputFormData(prev => ({ ...prev, userId: e.target.value }))}
                      required
                      aria-required="true"
                    >
                      <option value="">Select associate</option>
                      {users.map(u => (
                        <option key={u.id} value={u.id}>{u.name} — {u.email}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="manual-input-week-start">Week start <span className="required">*</span></label>
                    <input
                      id="manual-input-week-start"
                      type="date"
                      value={manualInputFormData.weekStartDate}
                      onChange={(e) => handleManualInputWeekDateChange('weekStartDate', e.target.value)}
                      required
                      aria-required="true"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="manual-input-week-end">Week end <span className="required">*</span></label>
                    <input
                      id="manual-input-week-end"
                      type="date"
                      value={manualInputFormData.weekEndDate}
                      onChange={(e) => handleManualInputWeekDateChange('weekEndDate', e.target.value)}
                      required
                      aria-required="true"
                    />
                  </div>
                </div>
              </section>

              <section className="manual-input-section">
                <h4 className="manual-input-section-title">Hours per day</h4>
                <p className="manual-input-hint">Enter hours for each day (0–24). Use 0.25 increments (e.g. 8, 8.25, 7.5).</p>
                <div className="manual-input-days-grid">
                  {['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map((day, index) => {
                    const hasWeekStart = !!manualInputFormData.weekStartDate;
                    const dateLabel = hasWeekStart
                      ? moment(manualInputFormData.weekStartDate).add(index, 'days').format('MM/DD')
                      : '';
                    const dayLabel = day.charAt(0).toUpperCase() + day.slice(1);
                    return (
                      <div key={day} className="form-group manual-input-day">
                        <label htmlFor={`manual-input-${day}`}>
                          {dayLabel}{dateLabel ? ` (${dateLabel})` : ''}
                        </label>
                        <input
                          id={`manual-input-${day}`}
                          type="number"
                          step="0.25"
                          min="0"
                          max="24"
                          placeholder="0"
                          value={manualInputFormData.hours[day]}
                          onChange={(e) => handleManualInputDayChange(day, e.target.value)}
                          aria-label={`Hours for ${dayLabel}${dateLabel ? ` on ${dateLabel}` : ''}`}
                        />
                      </div>
                    );
                  })}
                </div>
              </section>

              <section className="manual-input-section manual-input-summary-section">
                <div className="manual-input-total-row">
                  <label className="manual-input-total-label">Regular hours (total)</label>
                  <div className="manual-input-total-value">{manualInputTotalHours()} hrs</div>
                </div>
                <div className="form-group">
                  <label htmlFor="manual-input-notes">Notes <span className="optional">(optional)</span></label>
                  <textarea
                    id="manual-input-notes"
                    value={manualInputFormData.notes}
                    onChange={(e) => handleManualInputNotesChange(e.target.value)}
                    rows={3}
                    placeholder="Add any notes for this timesheet…"
                  />
                </div>
              </section>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={handleCloseManualInputModal} disabled={manualInputSaving}>
                Cancel
              </button>
              <button type="button" className="btn-primary" onClick={handleManualInputSave} disabled={manualInputSaving}>
                {manualInputSaving ? 'Saving…' : 'Save timesheet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Dashboard;

